import { CommonModule, DatePipe } from '@angular/common';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { DialogModule } from '@progress/kendo-angular-dialog';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { TooltipsModule } from '@progress/kendo-angular-tooltip';
import { CustomErrorHandler } from 'src/app/core/services/common/custom-error-handler.service';
import { AccountBubbleComponent } from './account-bubble/account-bubble.component';
import { AlertIconComponent } from './alert-icon/alert-icon.component';
import { AreYouSureComponent } from './are-you-sure/are-you-sure.component';
import { ContactSideswipeComponent } from './contact-sideswipe/contact-sideswipe.component';
import { ErrorBoundaryComponent } from './error-boundary/error-boundary.component';
import { FooterComponent } from './footer/footer.component';
import { InternalLinkComponent } from './internal-link/internal-link.component';
import { PrimaryButtonComponent } from './primary-button/primary-button.component';
import { SecondaryButtonComponent } from './secondary-button/secondary-button.component';
import { ServersideAlertComponent } from './serverside-alert/serverside-alert.component';
import { ShimmerLoaderComponent } from './shimmer-loader/shimmer-loader.component';
import { SuccessIconDialogComponent } from './success-icon-dialog/success-icon-dialog.component';
import { ToolTipComponent } from './tool-tip/tool-tip.component';

const components = [
  FooterComponent,
  ToolTipComponent,
  ContactSideswipeComponent,
  PrimaryButtonComponent,
  SecondaryButtonComponent,
  InternalLinkComponent,
  ServersideAlertComponent,
  AccountBubbleComponent,
  ErrorBoundaryComponent,
  AlertIconComponent,
  ShimmerLoaderComponent,
  AreYouSureComponent,
  SuccessIconDialogComponent,
];

const modules = [
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  CommonModule,
  LoaderModule,
  TooltipsModule,
  DialogModule,
];

@NgModule({
  declarations: [...components],
  imports: [...modules],
  exports: [...components, ...modules],
  providers: [
    DatePipe,
    ErrorBoundaryComponent,
    { provide: ErrorHandler, useClass: CustomErrorHandler },
  ],
})
export class CommonSharedModule {}
